import { useContext } from "react";
import Subtitle from "../../../../components/subtitle";
import Text from "../../../../components/text";
import Title from "../../../../components/title";
import { BsBoxArrowUpRight, BsDownload } from "react-icons/bs";
import ToastContext from "../../../../contexts/toast";
import aux from "../../../../utils/auxiliar";

interface IProps {
  data: any;
  getFile: (arquivoId: number) => Promise<{ base64?: string; errorMessage?: string }>;
  showDoc: (base64: string) => void;
}

const CardBoletoMobile: React.FC<IProps> = ({ data, getFile, showDoc }) => {
  const { showErrorToast } = useContext(ToastContext);

  async function abrirBoleto() {
    const file = await getFile(Number(data.arquivo));

    if (file.base64) showDoc(file.base64);
    else if (file.errorMessage) showErrorToast(file.errorMessage);
  }

  async function handleDownload() {
    const file = await getFile(Number(data.arquivo));

    if (file.base64) {
      aux.downloadFile(file.base64, data.timestamp);
    } else if (file.errorMessage) {
      showErrorToast(file.errorMessage);
    }
  }

  return (
    <div className="w-full rounded-xl border border-gray-100 bg-white overflow-hidden shadow-sm mb-4">

      <div className="px-5 pt-3.5 pb-1 border-b border-gray-100">
        <Text className="!text-[14px] !font-bold">
          {data["Empresa"]}
        </Text>
      </div>

      <div className="px-6 pt-2.5 pb-3.5 border-b border-gray-100 flex justify-between">
        <div>
          <Subtitle className="!text-gray-400 !text-[11px]">Banco</Subtitle>
          <Text className="!text-[14px]">
            {data["Banco"]}
          </Text>
        </div>
        <div className="ml-2">
          <Subtitle className="!text-gray-400 !text-[11px]">Emissão</Subtitle>
          <Text className="!text-[14px]">
            {data["Emissão"]}
          </Text>
        </div>

        <div className="text-right ml-3">
          <Subtitle className="!text-gray-400 !text-[11px]">Vencimento</Subtitle>
          <Text className="!text-[14px]">
            {data["Venc. Boleto"]}
          </Text>
        </div>
      </div>

      <div className="px-4 py-2.5 bg-[#F3F4F6] rounded-md flex justify-between items-center mx-4">
        <div>
          <Subtitle className="!text-gray-400 !text-[11px]">Bruto</Subtitle>
          <Title>{data["Val. Bruto"]}</Title>
        </div>

        <div className="ml-2">
          <Subtitle className="!text-gray-400 !text-[11px]">Líquido</Subtitle>
          <Title>{data["Val. Liquido"]}</Title>
        </div>

        <div className="text-right ml-2">
          <Subtitle className="!text-gray-400 !text-[11px]">Boleto</Subtitle>
          <Title>{data["Val. Boleto"]}</Title>
        </div>
      </div>

      <div className="px-5 pb-2.5 pt-3 flex justify-between items-center">


        <div className="flex items-center gap-3">
          <BsDownload
            size={15}
            className="text-[rgb(41,145,214)] cursor-pointer"
            onClick={handleDownload}
          />

          <BsBoxArrowUpRight
            size={15}
            className="text-[rgb(41,145,214)] cursor-pointer"
            onClick={abrirBoleto}
          />
        </div>
        <div className="flex flex-col">
          <Text className="!font-black !text-[12px]">
            NF: {data["NF"]}
          </Text>
        </div>
      </div>

    </div>
  );
};

export default CardBoletoMobile;